import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "language": "Language",
      "logout": "Log Out",
      "profile": "My Profile",
      "settings": "Settings",
      "search": "Search...",
      "cancel": "Cancel",
      "profile.change_password": "Change Password",
      "profile.administrator": "Administrator",
      
      // Sidebar / Navigation
      "nav.dashboard": "Dashboard",
      "nav.stores": "Store Management",
      "nav.products": "Product Approvals",
      "nav.categories": "Categories",
      "nav.orders": "Order Management",
      "nav.users": "User Management",
      "nav.delivery": "Delivery Partners",
      "nav.kyc": "KYC Approvals",
      "nav.wallet": "Wallet & Payouts",
      "nav.settings": "Platform Settings",
      "nav.banners": "Banners",
      "nav.cms": "CMS Pages",
      "nav.coupons": "Coupons",
      "nav.referrals": "Referral Levels",
      "nav.email": "Email Settings",
      "nav.integrations": "Integrations",
      "nav.profile": "My Profile",
      "nav.notifications": "Notifications",
      "nav.payouts": "Payouts & Adjust",
      "nav.wallet_transactions": "Transactions",
      "nav.settings_platform": "Platform",
      "nav.section_main": "MAIN",
      "nav.section_content": "CONTENT",
      "nav.section_manage": "MANAGE",
      "nav.section_finance": "FINANCE",
      "nav.section_settings": "SETTINGS",

      // Login Screen
      "login.username": "Username",
      "login.username_placeholder": "Enter your username (e.g. BM00001)",
      "login.password": "Password",
      "login.password_placeholder": "Enter your password",
      "login.forgot_password": "Forgot password?",
      "login.remember_me": "Keep me signed in",
      "login.submit": "Sign in",
      "login.submitting": "Signing in...",
      "login.otp": "Phone OTP",
      "login.new_title": "New to Bihari Mall?",
      "login.register_user": "Register User",
      "login.register_store": "Register Your Store",
      "login.join_delivery": "Join as Delivery Partner",
      "login.seller_info": "Seller Info",
      "login.want_to_sell": "Want to sell?",

      // Referral Levels Page
      "referrals.title": "Referral Levels",
      "referrals.subtitle": "Add, edit, or configure the platform referral levels to distribute the commission structure across active levels as you want.",
      "referrals.cashback_info": "Platform Settings → Level cashback % is the total budget (e.g. 40% of product BV). Each level's commission % is taken from product BV. Sum of active level % must not exceed that budget. Missing upline for a level flushes that share.",
      "referrals.add_level": "Add Level",
      "referrals.edit_level": "Edit Level",
      "referrals.level_number": "Level Number",
      "referrals.commission_percent": "Commission %",
      "referrals.status": "Status",
      "referrals.actions": "Actions",
      "referrals.active": "Active",
      "referrals.inactive": "Inactive",

      // Panel Sidebar
      "panel.overview": "Overview",
      "panel.profile": "Profile",
      "panel.personal_info": "Personal Info",
      "panel.member_id": "Member ID",
      "panel.kyc": "KYC Verification",
      "panel.my_orders": "My Orders",
      "panel.wallet": "Wallet",
      "panel.wallet_balance": "Balance & P2P",
      "panel.transactions": "Transactions",
      "panel.rewards": "Rewards & BV",
      "panel.referrals": "Referrals",
      "panel.my_team": "My Team",
      "panel.direct_referral": "Direct Referral",
      "panel.level_list": "Level List",
      "panel.income_reports": "Income Reports",
      "panel.self_cashback": "Self Cashback",
      "panel.level_income": "Level Income",
      "panel.reward_income": "Reward Income",
      "panel.addresses": "Addresses",
      "panel.notifications": "Notifications",
      "panel.products": "Products",
      "panel.orders": "Orders",
      "panel.earnings": "Earnings",
      "panel.store_kyc": "Store KYC",
      "panel.dashboard": "Dashboard",
      "panel.my_deliveries": "My Deliveries",

      // KYC Approvals Page
      "kyc.title": "KYC Approvals",
      "kyc.subtitle": "Verify and manage customer KYC verification requests",
      "kyc.search_placeholder": "Search name, email, phone...",
      "kyc.all_status": "All Statuses",
      "kyc.pending": "Pending",
      "kyc.verified": "Verified",
      "kyc.rejected": "Rejected",
      "kyc.user": "User",
      "kyc.status": "KYC Status",
      "kyc.submitted_at": "Submitted At",
      "kyc.actions": "Actions",
      "kyc.details": "KYC Details",
      "kyc.personal_details": "Personal Details",
      "kyc.identity_details": "Identity Verification",
      "kyc.bank_details": "Bank Account Details",
      "kyc.full_name": "Full Name",
      "kyc.aadhaar": "Aadhaar Number",
      "kyc.pan": "PAN Number",
      "kyc.bank_name": "Bank Name",
      "kyc.account_name": "Account Name",
      "kyc.account_number": "Account Number",
      "kyc.ifsc": "IFSC Code",
      "kyc.approve": "Approve",
      "kyc.reject": "Reject",
      "kyc.reject_title": "Reject KYC Submission",
      "kyc.reject_description": "Please enter the reason for rejecting this KYC request. This will be shown to the customer.",
      "kyc.rejection_reason": "Rejection Reason",
      "kyc.reason_placeholder": "e.g. Document image blurry or details mismatch"
    }
  },
  hi: {
    translation: {
      "language": "भाषा",
      "logout": "लॉग आउट",
      "profile": "मेरी प्रोफ़ाइल",
      "settings": "सेटिंग्स",
      "search": "खोजें...",
      "cancel": "रद्द करें",
      "profile.change_password": "पासवर्ड बदलें",
      "profile.administrator": "प्रशासक",

      // Sidebar / Navigation
      "nav.dashboard": "डैशबोर्ड",
      "nav.stores": "स्टोर प्रबंधन",
      "nav.products": "उत्पाद अनुमोदन",
      "nav.categories": "श्रेणियाँ",
      "nav.orders": "ऑर्डर प्रबंधन",
      "nav.users": "उपयोगकर्ता प्रबंधन",
      "nav.delivery": "डिलिवरी पार्टनर्स",
      "nav.kyc": "केवाईसी अनुमोदन",
      "nav.wallet": "वॉलेट और भुगतान",
      "nav.settings": "प्लेटफ़ॉर्म सेटिंग्स",
      "nav.banners": "बैनर",
      "nav.cms": "सीएमएस पेज",
      "nav.coupons": "कूपन",
      "nav.referrals": "रेफरल स्तर",
      "nav.email": "ईमेल सेटिंग्स",
      "nav.integrations": "एकीकरण",
      "nav.profile": "मेरी प्रोफ़ाइल",
      "nav.notifications": "सूचनाएं",
      "nav.payouts": "भुगतान और समायोजन",
      "nav.wallet_transactions": "लेन-देन",
      "nav.settings_platform": "प्लेटफ़ॉर्म",
      "nav.section_main": "मुख्य",
      "nav.section_content": "सामग्री",
      "nav.section_manage": "प्रबंधन",
      "nav.section_finance": "वित्त",
      "nav.section_settings": "सेटिंग्स",

      // Login Screen
      "login.username": "यूज़रनेम",
      "login.username_placeholder": "अपना यूज़रनेम दर्ज करें (जैसे BM00001)",
      "login.password": "पासवर्ड",
      "login.password_placeholder": "अपना पासवर्ड दर्ज करें",
      "login.forgot_password": "पासवर्ड भूल गए?",
      "login.remember_me": "मुझे लॉग इन रखें",
      "login.submit": "साइन इन करें",
      "login.submitting": "साइन इन हो रहा है...",
      "login.otp": "फ़ोन ओटीपी",
      "login.new_title": "बिहारी मॉल में नए हैं?",
      "login.register_user": "उपयोगकर्ता पंजीकरण",
      "login.register_store": "अपना स्टोर पंजीकृत करें",
      "login.join_delivery": "डिलिवरी पार्टनर बनें",
      "login.seller_info": "विक्रेता जानकारी",
      "login.want_to_sell": "बेचना चाहते हैं?",

      // Referral Levels Page
      "referrals.title": "रेफरल स्तर (Referral Levels)",
      "referrals.subtitle": "कमीशन संरचना को सक्रिय स्तरों में अपनी इच्छानुसार वितरित करने के लिए प्लेटफ़ॉर्म रेफरल स्तरों को जोड़ें, संपादित करें या कॉन्फ़िगर करें।",
      "referrals.cashback_info": "प्लेटफ़ॉर्म सेटिंग्स → स्तर कैशबैक % कुल बजट है (उदा. उत्पाद बीवी का 40%)। प्रत्येक स्तर का कमीशन % उत्पाद बीवी से लिया जाता है। सक्रिय स्तर % का योग उस बजट से अधिक नहीं होना चाहिए। किसी स्तर के लिए अपलाइन न होने पर वह हिस्सा फ्लश हो जाता है।",
      "referrals.add_level": "स्तर जोड़ें",
      "referrals.edit_level": "स्तर संपादित करें",
      "referrals.level_number": "स्तर संख्या",
      "referrals.commission_percent": "कमीशन %",
      "referrals.status": "स्थिति",
      "referrals.actions": "कार्रवाई",
      "referrals.active": "सक्रिय",
      "referrals.inactive": "निष्क्रिय",

      // Panel Sidebar
      "panel.overview": "अवलोकन",
      "panel.profile": "प्रोफ़ाइल",
      "panel.personal_info": "व्यक्तिगत जानकारी",
      "panel.member_id": "सदस्य आईडी",
      "panel.kyc": "केवाईसी सत्यापन",
      "panel.my_orders": "मेरे ऑर्डर",
      "panel.wallet": "वॉलेट",
      "panel.wallet_balance": "बैलेंस और पी2पी",
      "panel.transactions": "लेन-देन",
      "panel.rewards": "पुरस्कार और बीवी",
      "panel.referrals": "रेफरल",
      "panel.my_team": "मेरी टीम",
      "panel.direct_referral": "डायरेक्ट रेफरल",
      "panel.level_list": "लेवल लिस्ट",
      "panel.income_reports": "आय रिपोर्ट",
      "panel.self_cashback": "सेल्फ कैशबैक",
      "panel.level_income": "लेवल आय",
      "panel.reward_income": "रिवॉर्ड आय",
      "panel.addresses": "पते",
      "panel.notifications": "सूचनाएं",
      "panel.products": "उत्पाद",
      "panel.orders": "ऑर्डर",
      "panel.earnings": "कमाई",
      "panel.store_kyc": "स्टोर केवाईसी",
      "panel.dashboard": "डैशबोर्ड",
      "panel.my_deliveries": "मेरी डिलीवरी",

      // KYC Approvals Page
      "kyc.title": "केवाईसी अनुमोदन",
      "kyc.subtitle": "ग्राहक केवाईसी सत्यापन अनुरोधों को सत्यापित और प्रबंधित करें",
      "kyc.search_placeholder": "नाम, ईमेल, फोन खोजें...",
      "kyc.all_status": "सभी स्थितियाँ",
      "kyc.pending": "लंबित",
      "kyc.verified": "सत्यापित",
      "kyc.rejected": "अस्वीकृत",
      "kyc.user": "उपयोगकर्ता",
      "kyc.status": "केवाईसी स्थिति",
      "kyc.submitted_at": "जमा करने की तिथि",
      "kyc.actions": "कार्रवाई",
      "kyc.details": "केवाईसी विवरण",
      "kyc.personal_details": "व्यक्तिगत विवरण",
      "kyc.identity_details": "पहचान सत्यापन",
      "kyc.bank_details": "बैंक खाता विवरण",
      "kyc.full_name": "पूरा नाम",
      "kyc.aadhaar": "आधार संख्या",
      "kyc.pan": "पैन संख्या",
      "kyc.bank_name": "बैंक का नाम",
      "kyc.account_name": "खाता धारक का नाम",
      "kyc.account_number": "खाता संख्या",
      "kyc.ifsc": "आईएफएससी कोड",
      "kyc.approve": "स्वीकृत करें",
      "kyc.reject": "अस्वीकार करें",
      "kyc.reject_title": "केवाईसी सबमिशन अस्वीकार करें",
      "kyc.reject_description": "कृपया इस केवाईसी अनुरोध को अस्वीकार करने का कारण दर्ज करें। यह ग्राहक को दिखाया जाएगा।",
      "kyc.rejection_reason": "अअस्वीकृति का कारण",
      "kyc.reason_placeholder": "जैसे: दस्तावेज़ की छवि धुंधली है या विवरण मेल नहीं खाता"
    }
  }
};

const savedLanguage = localStorage.getItem("language") || "en";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
